export const SHIP_FREE_MODAL_PATH = 'ship_free_modal';
